import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Home, UserRound } from 'lucide-react';
import {
  Icon,
  IconButton,
  LanguageSwitcher,
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Stack,
  Text,
} from '@ui-kit';
import { useLanguage } from '@miniapp-core/context/LanguageContext';
import { useMiniAppAuth } from '../context/AuthContext';

export default function MiniappHeaderActions() {
  const { t } = useTranslation('shell');
  const navigate = useNavigate();
  const auth = useMiniAppAuth();
  const { languages, languageCode, changing, setLanguage } = useLanguage();
  const user = auth.status === 'authenticated' ? auth.user : null;
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.username;
  return (
    <>
      <IconButton variant="ghost" aria-label={t('navigation.home')} onClick={() => navigate('/')}>
        <Icon icon={Home} aria-hidden="true" />
      </IconButton>
      <LanguageSwitcher
        iconOnly
        languages={languages
          .filter((item) => item.enabled)
          .map((item) => ({ code: item.code, label: item.name }))}
        value={languageCode}
        disabled={changing}
        onChange={(code) => void setLanguage(code)}
      />
      <Dialog>
        <DialogTrigger asChild>
          <IconButton variant="ghost" aria-label={t('navigation.profile')}>
            <Icon icon={UserRound} aria-hidden="true" />
          </IconButton>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('navigation.profile')}</DialogTitle>
            <DialogDescription>{t('profile.description')}</DialogDescription>
          </DialogHeader>
          <Stack gap={3}>
            <Text>{name || t('profile.guest')}</Text>
            {user?.username ? <Text tone="muted">{`@${user.username}`}</Text> : null}
            {user?.email ? <Text>{user.email}</Text> : null}
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
